import {type VariantProps} from 'class-variance-authority';
import * as React from 'react';

import {cn} from '@/utils/ui';

import {Button} from '../button';
import {alertVariants} from './alert-variants';

function Alert({
  className,
  variant,
  ...props
}: React.ComponentProps<'div'> & VariantProps<typeof alertVariants>) {
  return (
    <div
      data-slot="alert"
      role="alert"
      className={cn(alertVariants({variant}), className)}
      {...props}
    />
  );
}

function AlertTitle({className, ...props}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="alert-title"
      className={cn(
        'col-start-2 line-clamp-1 min-h-5 font-urbanist text-sm leading-5 font-medium tracking-normal',
        className
      )}
      {...props}
    />
  );
}

function AlertDescription({className, ...props}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="alert-description"
      className={cn(
        'col-start-2 grid justify-items-start gap-1 text-sm leading-5 [&_p]:leading-relaxed',
        className
      )}
      {...props}
    />
  );
}

function AlertAction({className, ...props}: React.ComponentProps<'button'>) {
  return (
    <Button
      data-slot="alert-action"
      variant="secondary"
      size="small"
      className={cn(
        'col-start-2 mt-2 h-9 w-fit rounded-full border-current px-4 py-2 text-sm leading-5 font-normal hover:border-current hover:bg-current/10 hover:text-inherit focus-visible:border-current focus-visible:text-inherit focus-visible:ring-current active:border-current active:bg-current/15 active:text-inherit disabled:border-current disabled:text-inherit disabled:opacity-50',
        className
      )}
      {...props}
    />
  );
}

export {Alert, AlertAction, AlertDescription, AlertTitle};
